import { render, staticRenderFns } from "./AspectRatio.vue?vue&type=template&id=b1fa7980&scoped=true"
import script from "./AspectRatio.vue?vue&type=script&lang=js"
export * from "./AspectRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fa7980",
  null
  
)

export default component.exports